import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

// Connects to data-controller="video-action-cable"
export default class extends Controller {
  static values = { videoId: String }
  static outlets = ["highlight-transcript", "video-block-load"]
  static targets = ["block", "castChanges"]

  connect() {
    this.actionCable = consumer.subscriptions.create(
      {
        channel: "VideoUpdateChannel",
        video_id: this.videoIdValue,
      },
      {
        received: (data) => { this.handleActionCable(data) },
      }
    )
  }

  disconnect() {
    this.actionCable.unsubscribe()
  }

  handleActionCable(data) {
    console.log(data)
    switch (data.type) {
      case "chunk_stt":
        this.#handleChunkStt(data)
        break
      case "cast_changes":
        this.#handleCastChanges(data)
        break
    }
  }

  #handleChunkStt(data) {
    if (data.start_time === undefined || data.end_time === undefined) {
      console.error("start_time and end_time are required")
      return
    }
    const { start_time, end_time } = data
    this.videoBlockLoadOutlets.forEach((outlet) => {
      outlet.reloadByTime(start_time, end_time)
    })
  }
  #handleCastChanges(data) {
    if (data.casts === undefined) {
      console.error("casts are required")
      return
    }
    const { casts } = data
    this.highlightTranscriptOutlets.forEach((outlet) => {
      outlet.castsValue = casts
    })
  }

  #reloadTurboFrame(elem) {
    const isTurboFrame = elem.matches("turbo-frame")
    if (!isTurboFrame) return

    elem.setAttribute("src", elem.getAttribute("src"))
  }

}
